import React, {
  memo, useCallback, useEffect, useMemo, useRef,
} from 'react';
import PropTypes from 'prop-types';
import Swiper from 'swiper';
import _ from 'lodash';
import {t} from '../../services/i18nHandler';
import {mediaSizes} from '../../configs/media';

const partnersData = [
  {iconClassName: 'sberbank', text: 'Sberbank', key: 'Sberbank'},
  {iconClassName: 'mts', text: 'MTS', key: 'MTC'},
  {iconClassName: 'rosneft', text: 'Rosneft', key: 'Rosneft'},
  {iconClassName: 'auchan', text: 'Auchan', key: 'Auchan'},
  {iconClassName: 'skolkovo', text: 'Skolkovo', key: 'Skolkovo'},
  {iconClassName: 'raiffeisenbank', text: 'Raiffeisen Bank', key: 'RaiffeisenBank'},
  {iconClassName: 'mcdonalds', text: 'McDonalds', key: 'McDonalds'},
  {iconClassName: 'megafon', text: 'Megafon', key: 'Megafon'},
  {iconClassName: 'bosch', text: 'Bosch', key: 'Bosch'},
  {iconClassName: 'pepsico', text: 'Pepsico', key: 'Pepsico'},
  {iconClassName: 'britishamericantobacco', text: 'British American Tobacco', key: 'BritichAmericanTabacco'},
  {iconClassName: 'evraz', text: 'Evraz', key: 'Evraz'},
  {iconClassName: 'bmw', text: 'BMW Russia Group', key: 'BMW'},
  {iconClassName: 'beeline', text: 'Beeline', key: 'Beeline'},
  {iconClassName: 'danone', text: 'Danone', key: 'Danone'},
  {iconClassName: 'krok', text: 'Krok', key: 'Krok'},
  {iconClassName: 'citibank', text: 'Citibank', key: 'Citibank'},
  {iconClassName: 'rostelecom', text: 'Rostelecom', key: 'Rostelekom'},
  {iconClassName: 'siburholding', text: 'Sibur Holding', key: 'SiburHolding'},
  {iconClassName: 'lukoil', text: 'Lukoil', key: 'Lukoli'},
  {iconClassName: 'metro', text: 'Metro', key: 'Metro'},
  {iconClassName: 'deloitte', text: 'Deloitte', key: 'Deloitte'},
  {iconClassName: 'unilever', text: 'Unilever', key: 'Unilever'},
  {iconClassName: 'yandex', text: 'Yandex', key: 'Yandex'},
];

function LandingPagePartnersSection({partnersSettings, windowWidth}) {
  const swiperRef = useRef();

  const containerRef = useRef();

  const paginationRef = useRef();

  const responsiveView = useMemo(() => (windowWidth < mediaSizes.xx), [windowWidth]);

  const partnersList = useMemo(() => (partnersData.filter((p) => {
    if (partnersSettings.length) {
      return !!_.find(partnersSettings, {key: p.key, enabled: true});
    }
    return true;
  })), [partnersSettings]);

  const sliceSize = useMemo(() => {
    if (windowWidth < mediaSizes.sm) {
      return 2;
    }
    if (windowWidth < mediaSizes.xx) {
      return 12;
    }
    return partnersList.length;
  }, [windowWidth]);

  const chunkedList = useMemo(() => (_.chunk(partnersList, sliceSize)), [partnersList, sliceSize]);

  const destroySwiper = useCallback(() => {
    if (swiperRef.current) {
      swiperRef.current.destroy(true, true);
    }
  }, []);

  const initSwiper = useCallback(() => {
    destroySwiper();
    swiperRef.current = new Swiper(containerRef.current, {
      slidesPerView: 'auto',
      pagination: {
        el: paginationRef.current,
      },
    });
  }, []);

  useEffect(() => {
    if (responsiveView) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }, [responsiveView, chunkedList.length]);

  return (
    <div className="section section--partners" data-anchor="partners">
      <div className="section--inner">
        <div className="section--container">
          <div className="section--partners--content">
            <div className="section--slogan">{t('landingPage.partners.slogan')}</div>
            <div className="section--title">{t('landingPage.partners.title')}</div>
            <div className="partners_wrap desctop">
              {!responsiveView && (
                <div className="partners_list">
                  <div className="row">
                    {partnersList.map((p) => (
                      <div className="col-lg-2 col-md-3 col-sm-4 col-6 partners_item-wrap" key={p.key}>
                        <div className="partners_item">
                          <div className="partners_img-wrap">
                            <div className={`partners_img ${p.iconClassName}`} />
                          </div>
                          <div className="partners_name">
                            {p.text}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {responsiveView && (
                <>
                  <div className="swiper-pagination" ref={paginationRef} />
                  <div className="swiper-container" ref={containerRef}>
                    <div className="swiper-wrapper">
                      {chunkedList.map((list, index) => {
                        return (
                          <div className="swiper-slide" key={index}>
                            <div className="partners_item_wrap">
                              {list.map((p) => (
                                <div className="partners_item" key={p.key}>
                                  <div className="partners_img-wrap">
                                    <div className={`partners_img ${p.iconClassName}`}/>
                                  </div>
                                  <div className="partners_name">
                                    {p.text}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

LandingPagePartnersSection.propTypes = {};

export default memo(LandingPagePartnersSection);
